import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  line-height: 0;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  position: relative;
  user-select: none;
`;
